import { Box } from '@mui/material'
import SectionTitle from '../SectionTitle'
import SettingsRow from '../SettingsRow'
import Divider from '@mui/material/Divider'
import React from 'react'
import { useApplicationSuiteContext } from '../../../contexts/ApplicationSuiteProvider'

function AccountSettings({ backtest }: any) {
  const { usermeta, canShowcaseViewBacktestSettings } = useApplicationSuiteContext()

  if (!backtest) {
    return null
  }

  const ownsBacktest = backtest.gcid === usermeta.gcid

  const equity = `$${backtest.backtestSettings.analyzeTrades.equity.toFixed(2)}`
  const riskPerTrade = `${backtest.backtestSettings.analyzeTrades.riskPerTrade * 100}%`
  const commissions = `$${backtest.backtestSettings.analyzeTrades.commissions.toFixed(2)}`
  const spreadPoints = backtest.backtestSettings.analyzeTrades.spread
  const spread =
    spreadPoints === null || spreadPoints === undefined ? 'Standard' : `${spreadPoints} points`
  const maxOpenPositions = backtest.backtestSettings.analyzeTrades.tradeLimit
    ? `${backtest.backtestSettings.analyzeTrades.tradeLimit}`
    : '∞'
  const hedging = backtest.backtestSettings.analyzeTrades.allowHedging ? 'Hedging' : 'No Hedging'
  const maxRisk = backtest.backtestSettings.analyzeTrades.maxRisk
    ? `${backtest.backtestSettings.analyzeTrades.maxRisk * 100}%`
    : '∞'
  const dailyTradeLimit = backtest.backtestSettings.analyzeTrades.dailyTradeLimit
    ? `${backtest.backtestSettings.analyzeTrades.dailyTradeLimit}`
    : '∞'
  const contractSize = backtest.backtestSettings.analyzeTrades.contractSize

  return (
    <Box>
      <SectionTitle title={'Account Settings'} />
      <SettingsRow
        title={'Equity'}
        data={
          canShowcaseViewBacktestSettings || ownsBacktest
            ? equity
            : 'Backtest settings not available'
        }
      />
      <SettingsRow
        title={'Risk Per Trade'}
        data={
          canShowcaseViewBacktestSettings || ownsBacktest
            ? riskPerTrade
            : 'Backtest settings not available'
        }
      />
      <SettingsRow
        title={'Commissions'}
        data={
          canShowcaseViewBacktestSettings || ownsBacktest
            ? commissions
            : 'Backtest settings not available'
        }
      />
      <SettingsRow
        title={'Spread'}
        data={
          canShowcaseViewBacktestSettings || ownsBacktest
            ? spread
            : 'Backtest settings not available'
        }
      />
      <SettingsRow
        title={'Max Open Positions'}
        data={
          canShowcaseViewBacktestSettings || ownsBacktest
            ? maxOpenPositions
            : 'Backtest settings not available'
        }
      />
      <SettingsRow
        title={'Hedging'}
        data={
          canShowcaseViewBacktestSettings || ownsBacktest
            ? hedging
            : 'Backtest settings not available'
        }
      />
      <SettingsRow
        title={'Max Risk'}
        data={
          canShowcaseViewBacktestSettings || ownsBacktest
            ? maxRisk
            : 'Backtest settings not available'
        }
      />
      <SettingsRow
        title={'Daily Trade Limit'}
        data={
          canShowcaseViewBacktestSettings || ownsBacktest
            ? dailyTradeLimit
            : 'Backtest settings not available'
        }
      />
      <SettingsRow
        title={'Contract Size'}
        data={
          canShowcaseViewBacktestSettings || ownsBacktest
            ? contractSize
            : 'Backtest settings not available'
        }
      />
      <Divider />
    </Box>
  )
}

export default AccountSettings
